import {
    Badge,
    Box,
    Button,
    Container,
    Group,
    Paper,
    Stack,
    Text,
    TextInput,
    Title,
    Pagination,
    Loader,
    Center,
    Modal,
    Divider, Grid, ActionIcon
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
    IconSearch,
    IconGavel,
} from "@tabler/icons-react";

import { useEffect, useState } from "react";
import Newnavbar from "../Components/Navbar/Newnavbar";
import { Userauthcontexthooks } from "../Hooks/Userauthcontexthooks";

const Viewalllegalupdates = () => {

    const { user } = Userauthcontexthooks();
    const isMobile = useMediaQuery("(max-width: 900px)");
    const [updates, setUpdates] = useState([]);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [search, setSearch] = useState('');

    const [opened, setOpened] = useState(false);
    const [selectedUpdate, setSelectedUpdate] = useState(null);
    // const [userDetails, SetUserDetails] = useState(''); // for getting individual user details to check the profile completion for date alert feature and also to show the details in profile section of navbar.

    const GetLegalUpdates = async (
        currentPage = 1,
        searchText = ''
    ) => {

        setLoading(true);

        const res = await fetch(
            `https://cdr-backend.onrender.com/v2/get-all-legal-updates?page=${currentPage}&search=${searchText}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${user}`
                }
            }
        );

        const data = await res.json();

        if (res.status === 200) {

            setUpdates(data.updates);
            setPage(data.currentPage);
            setTotalPages(data.totalPages);
        }

        setLoading(false);
    };

    useEffect(() => {
        const GetLegalUpdates = async (
            currentPage = 1,
            searchText = ''
        ) => {

            setLoading(true);

            const res = await fetch(
                `https://cdr-backend.onrender.com/v2/get/all-legal-updates?page=${currentPage}&search=${searchText}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user}`
                    }
                }
            );

            const data = await res.json();

            if (res.status === 200) {

                setUpdates(data.updates);
                setPage(data.currentPage);
                setTotalPages(data.totalPages);
            }

            setLoading(false);
        };
        if (user) {
            GetLegalUpdates(page, search);
        }

    }, [user, page, search]);

    // useEffect(() => { // get individual user details
    //     const GetIndividualUser = async () => {
    //         const res = await fetch("http://localhost:8000/get/user-details", {
    //             method: 'GET',
    //             headers: {
    //                 'Content-type': 'application/json',
    //                 'Authorization': `Bearer ${user}`
    //             }
    //         });

    //         const Result = await res.json();
    //         if (res.status === 200) {
    //             SetUserDetails(Result.ExistingUser);
    //             return
    //         } else {
    //             return;
    //         }
    //     }
    //     if (user) {
    //         GetIndividualUser();
    //     }
    // }, [user])

    // const OpenProfile = (item) => {
    //     setSelectedUser(item);
    //     setOpened(true);
    // };

    return (
        <>
            {/* VIEW DETAILS MODAL */}
            <Modal // For Legal update details
                opened={opened}
                onClose={() => setOpened(false)}
                centered
                size="lg"
                radius="30px"
                title={
                    <Group gap="sm">
                        <ActionIcon
                            variant="light"
                            color="yellow"
                            radius="xl"
                        >
                            <IconGavel size={18} />
                        </ActionIcon>

                        <Text fw={700}>
                            Legal Update Details
                        </Text>
                    </Group>
                }
                styles={{
                    content: {
                        background:
                            "linear-gradient(135deg,#0f172a 0%,#111827 100%)",
                        border: "1px solid rgba(255,255,255,0.08)",
                    },
                    header: {
                        background: "rgba(15,23,42,0.95)",
                        borderBottom: '1px solid rgba(255,255,255,0.08)',
                    },
                }}
            >
                {selectedUpdate && (
                    <Stack>

                        <Group justify="space-between">

                            <Badge
                                size="lg"
                                variant="light"
                                color="yellow"
                            >
                                {selectedUpdate.category}
                            </Badge>

                            <Text size="sm" c="dimmed">
                                {new Date(
                                    selectedUpdate.createdAt
                                ).toLocaleDateString()}
                            </Text>

                        </Group>

                        {selectedUpdate.subdistcourt &&
                            selectedUpdate.category ===
                            "District Court" && (
                                <Paper
                                    p="sm"
                                    radius="md"
                                    bg="rgba(255,255,255,0.05)"
                                >
                                    <Text c="white">
                                        <b>Sub District Court:</b>{" "}
                                        {selectedUpdate.subdistcourt}
                                    </Text>
                                </Paper>
                            )}

                        <Title order={3} c="white">
                            {selectedUpdate.title}
                        </Title>

                        <Text c="#94a3b8">
                            {selectedUpdate.shortdescription}
                        </Text>

                        <Divider />

                        {/* Jodit HTML Content */}
                        <Box
                            style={{
                                color: "#e2e8f0",
                                lineHeight: 1.8,
                            }}
                            dangerouslySetInnerHTML={{
                                __html: selectedUpdate.content,
                            }}
                        />

                    </Stack>
                )}
            </Modal>
            <Box
                style={{
                    minHeight: "100vh",
                    background:
                        "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >

                {/* BACKGROUND GLOW */}

                <Box
                    style={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(59,130,246,0.15)",
                        filter: "blur(120px)",
                        top: -100,
                        right: -100,
                    }}
                />

                <Box
                    style={{
                        position: "absolute",
                        width: 400,
                        height: 400,
                        borderRadius: "50%",
                        background: "rgba(168,85,247,0.15)",
                        filter: "blur(120px)",
                        bottom: -100,
                        left: -100,
                    }}
                />

                {/* MAIN CONTENT */}

                <Box
                    px={{ base: "md", md: "xl" }}
                    py={{ base: "md", md: "lg" }}
                    style={{
                        position: "relative",
                        zIndex: 10,
                        paddingBottom: 100,
                    }}
                >

                    <Newnavbar />

                    <Container size="xl" mt="md" mb="xl">

                        {/* HEADER */}

                        <Group justify="space-between" mb="xl">

                            <Box>
                                <Title c="white">
                                    Legal Updates
                                </Title>

                                <Text c="#94a3b8" mt={4}>
                                    Find the latest legal updates, case summaries, and court rulings across various jurisdictions. Stay informed about the ever-evolving legal landscape with our comprehensive collection of legal news and insights.
                                </Text>
                            </Box>

                        </Group>
                        {/* SEARCH */}

                        <Paper
                            radius="25px"
                            p="md"
                            mb="xl"
                            style={{
                                background: "rgba(255,255,255,0.06)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                backdropFilter: "blur(20px)",
                            }}
                        >

                            <TextInput
                                placeholder="Search legal updates..."
                                leftSection={<IconSearch size={18} />}
                                radius="xl"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        setPage(1);
                                        GetLegalUpdates(1, search);
                                    }
                                }}
                                styles={{
                                    input: {
                                        background: "rgba(255,255,255,0.04)",
                                        border: "1px solid rgba(255,255,255,0.08)",
                                        color: "white",
                                        height: 50,
                                    },
                                }}
                            />
                        </Paper>
                        {loading ? (
                            <Center mt={100}>
                                <Loader color="blue" />
                            </Center>
                        ) : (

                            <Grid mt="xl">

                                {updates.map((item) => (

                                    <Grid.Col
                                        span={{ base: 12, md: 6 }}
                                        key={item._id}
                                    >

                                        <Paper
                                            radius="30px"
                                            p="xl"
                                            style={{
                                                background:
                                                    "rgba(255,255,255,0.08)",
                                                border:
                                                    "1px solid rgba(255,255,255,0.08)",
                                                backdropFilter: "blur(18px)",
                                                height: "100%",
                                            }}
                                        >

                                            <Group mb="md">

                                                <ActionIcon
                                                    variant="light"
                                                    color="yellow"
                                                    radius="xl"
                                                    size={50}
                                                >
                                                    <IconGavel size={24} />
                                                </ActionIcon>

                                                <Box>

                                                    <Group gap={5}>
                                                        <Text fw={700} c="white">
                                                            {item.category}
                                                        </Text>

                                                        {item.category ===
                                                            "District Court" &&
                                                            item.subdistcourt && (

                                                                <Text
                                                                    size="sm"
                                                                    c="dimmed"
                                                                >
                                                                    • {item.subdistcourt}
                                                                </Text>
                                                            )}
                                                    </Group>

                                                    <Text
                                                        size="sm"
                                                        c="#94a3b8"
                                                    >
                                                        {new Date(
                                                            item.createdAt
                                                        ).toLocaleDateString()}
                                                    </Text>

                                                </Box>

                                            </Group>

                                            <Text fw={600} c="white">
                                                {item.title}
                                            </Text>

                                            <Text
                                                c="#cbd5e1"
                                                size="sm"
                                                mt="xs"
                                                lineClamp={3}
                                            >
                                                {item.shortdescription}
                                            </Text>

                                            <Button
                                                mt="lg"
                                                radius="xl"
                                                variant="light"
                                                color="blue"
                                                onClick={() => {
                                                    setSelectedUpdate(item);
                                                    setOpened(true);
                                                }}
                                            >
                                                Read More
                                            </Button>

                                        </Paper>

                                    </Grid.Col>

                                ))}

                            </Grid>
                        )
                        }

                        {/* PAGINATION */}

                        <Center mt={40}>
                            {
                                isMobile ? (
                                    <Group justify="center" mt="xl">
                                        <Button
                                            variant="light"
                                            radius="xl"
                                            disabled={page === 1}
                                            onClick={() => setPage((prev) => prev - 1)}
                                        >
                                            ← Previous
                                        </Button>

                                        <Button
                                            variant="light"
                                            radius="xl"
                                            disabled={page === totalPages}
                                            onClick={() => setPage((prev) => prev + 1)}
                                        >
                                            Next →
                                        </Button>
                                    </Group>
                                ) : (
                                    <Pagination
                                        total={totalPages}
                                        value={page}
                                        onChange={setPage}
                                        radius="xl"
                                        style={{ cursor: "pointer" }}
                                    />
                                )
                            }
                            {/* <Pagination
                                total={totalPages}
                                value={page}
                                onChange={(newPage) => {
                                   // console.log("Selected Page:", newPage);
                                    setPage(newPage);
                                }}
                                radius="xl"
                                withPages={false}
                                //size={'lg'}
                                //withEdges
                                //style={{cursor: "pointer"}}
                            /> */}

                        </Center>


                    </Container>
                </Box>
            </Box>

        </>
    );
};

export default Viewalllegalupdates;